<template>
    <div class="videoplay" :class="{ big: isBig }">
        <template v-if="playState == 'loading'">
            <div class="video-box flex-center">
                <div class="container-loading animation-5">
                    <div class="shape shape1"></div>
                    <div class="shape shape2"></div>
                    <div class="shape shape3"></div>
                    <div class="shape shape4"></div>
                </div>
            </div>
        </template>
        <template v-if="playState == 'playing'"> </template>
        <template v-if="playState == 'abort'">
            <div class="video-box flex-center parse">
                <svg
                    @click="refresh"
                    class="abort"
                    style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                    viewBox="0 0 1024 1024"
                >
                    <path
                        d="M913.31200001 384.08853333L732.144 384.08853334c-23.11242666 0-41.80714667-18.72650667-41.80714667-41.80917334 0-23.08074667 18.69578667-41.80714667 41.80714667-41.80714666l72.72736-1e-8c-65.60416-92.70026667-173.48373333-153.296-295.70453333-153.296-200.11413333 0-362.33813333 162.22506667-362.33813334 362.336 0 200.11306667 162.22506667 362.33706667 362.33813334 362.33706667 200.11306667 0 362.33706667-162.22506667 362.33706666-362.33706667 0-23.08074667 18.69482667-41.80714667 41.80618666-41.80714666 23.08266666 0 41.81024 18.72650667 41.81024001 41.80714666 0 246.29226667-199.68 445.95413333-445.95413333 445.95413334-246.27733332 0-445.95519999-199.6608-445.9552-445.95413334 0-246.2912 199.67786667-445.95306667 445.9552-445.95306667 149.4688 0 281.488 73.69237333 362.33706666 186.59733334l0-75.10858667c0-23.08266666 18.69482667-41.80821333 41.80618667-41.80821333 23.08266666 0 41.81024 18.72554667 41.81024 41.80821333l0 167.232C955.12213333 365.36213333 936.39253333 384.08853333 913.31200001 384.08853333Z"
                        p-id="1617"
                    ></path>
                </svg>
            </div>
        </template>
        <template v-if="playState == 'pause'">
            <div class="video-box flex-center parse">
                <svg
                    @click="pause"
                    style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                    viewBox="0 0 1024 1024"
                >
                    <path
                        d="M121.3 676.4m-40.9 0a40.9 40.9 0 1 0 81.8 0 40.9 40.9 0 1 0-81.8 0Z"
                        p-id="2063"
                    ></path>
                    <path
                        d="M266.5 851.6m-40.9 0a40.9 40.9 0 1 0 81.8 0 40.9 40.9 0 1 0-81.8 0Z"
                        fill="#242424"
                        p-id="2064"
                    ></path>
                    <path
                        d="M512 31.6C252.8 31.6 42.6 241.7 42.6 501c0 69 14.9 134.6 41.7 193.6l74.2-35.4c-21.7-48.3-33.7-101.8-33.7-158.2 0-213.8 173.3-387.2 387.2-387.2S899.2 287.1 899.2 501 725.8 888.1 512 888.1c-81.9 0-157.9-25.4-220.4-68.8l-51.2 57.2c1.5 0.7 2.5 2.1 2.5 3.6s0.3 3.2-1.2 3.9c76.7 54.5 169.2 86.2 270.4 86.2 259.2 0 469.4-210.1 469.4-469.4S771.2 31.6 512 31.6z"
                        p-id="2065"
                    ></path>
                    <path
                        d="M379.9 348.8c11.3-19.6 36.4-26.3 55.9-15l226.6 130.9c19.6 11.3 26.3 36.4 15 55.9-11.3 19.6-36.4 26.3-55.9 15L394.9 404.7c-19.6-11.3-26.3-36.3-15-55.9z"
                        p-id="2066"
                    ></path>
                    <path
                        d="M416.2 328.3c22.6 0 41 18.3 41 41V631c0 22.6-18.3 41-41 41-22.6 0-41-18.3-41-41V369.2c0-22.6 18.4-40.9 41-40.9z"
                        p-id="2067"
                    ></path>
                    <path
                        d="M677.5 478.6c11.5 19.5 5.1 44.6-14.4 56.1L437.8 667.9c-19.5 11.5-44.6 5.1-56.1-14.4s-5.1-44.6 14.4-56.1l225.3-133.2c19.5-11.5 44.6-5 56.1 14.4z"
                    ></path>
                </svg>
            </div>
        </template>
        <template v-if="isReload">
            <video :id="getId" autoplay muted webkit-playsinline playsInline>
                <source :src="getHls" type="application/x-mpegURL" />
            </video>
        </template>
        <div class="control">
            <template v-if="playState != 'pause'">
                <svg
                    @click="pause"
                    class="icon"
                    style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2305"
                >
                    <path
                        d="M288 128C270.336 128 256 142.336 256 160l0 768C256 945.664 270.336 960 288 960S320 945.664 320 928l0-768C320 142.336 305.664 128 288 128zM672 128C654.336 128 640 142.336 640 160l0 768c0 17.664 14.336 32 32 32s32-14.336 32-32l0-768C704 142.336 689.664 128 672 128z"
                        p-id="2306"
                    ></path>
                </svg>
            </template>
            <template v-else>
                <svg></svg>
            </template>
            <svg
                @click="capture"
                class="icon"
                style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                viewBox="0 0 1071 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3916"
            >
                <path
                    d="M968.820352 518.33122c-15.440054 0-28.498093-11.536992-30.392225-26.86225V107.964427c0-15.899238 0-19.658805-2.898598-24.308041a14.349493 14.349493 0 0 0-6.026787-5.94069l-0.573979-0.315689h-0.688776a17.678575 17.678575 0 0 1-3.730868-0.57398 78.34823 78.34823 0 0 0-19.170922-1.894133H136.63587c-15.927937 0-19.716203 0-24.365439 2.898598a14.263396 14.263396 0 0 0-5.94069 5.998088l-0.315689 0.602678v0.660077c0 1.061862-0.258291 2.181123-0.602678 3.759567-0.746174 3.415179-1.894133 8.609696-1.894133 19.113525v383.848931c1.463648 12.024875-4.017858 23.619265-13.976406 29.904342a30.707914 30.707914 0 0 1-46.808046-29.559955L42.761488 107.964427a101.450914 101.450914 0 0 1 10.159441-52.490445A75.507031 75.507031 0 0 1 84.145425 24.364282 101.766603 101.766603 0 0 1 136.434977 14.23354h768.90322a102.168388 102.168388 0 0 1 52.576541 10.159441c13.258931 7.05995 24.04975 17.850769 31.138399 31.167098 8.007017 16.12883 11.508293 34.209191 10.159441 52.203455l-0.028699 384.049824c-1.836735 14.98087-14.923472 26.517863-30.363527 26.517862zM181.406287 642.999613a170.787663 170.787663 0 0 1 180.631415 118.641606l1.721939 5.338012 122.688163-181.205395-189.757692-275.998143a30.133935 30.133935 0 0 1 49.878837-33.577813l174.403735 257.286405 174.030648-257.4299a30.334828 30.334828 0 0 1 27.579725-14.866075 30.047838 30.047838 0 0 1 22.270413 48.472587l-187.318279 277.605286 122.171582 180.20093 1.721939-5.338011a170.787663 170.787663 0 0 1 163.297227-119.244285 171.677331 171.677331 0 0 1 171.218148 159.394166 171.533836 171.533836 0 0 1-171.132051 183.214323 172.423505 172.423505 0 0 1-154.572736-97.088668l-0.086097-0.200893-169.180519-247.098265-173.514067 257.401201a172.165214 172.165214 0 0 1-148.919035 86.240452 171.189449 171.189449 0 0 1-52.92093-8.380104C68.877565 951.513707 19.400514 875.317901 28.01021 795.190333c8.580997-80.127568 73.096316-144.126305 153.396077-152.19072z m563.160193 220.408209l0.143495 0.315689 0.229592 0.258291c1.205357 1.463648 2.295919 3.042092 3.214286 4.706633l-0.57398 0.57398 1.090562 1.808036a110.261502 110.261502 0 0 0 94.821448 54.269782c18.625642 0 37.107788-4.82143 53.46621-13.947707 51.77297-28.928577 71.202183-94.993642 43.27807-147.283194a109.630125 109.630125 0 0 0-146.565719-46.147969c-52.920929 26.86225-74.933051 92.095044-49.103964 145.446459zM197.362923 925.627222a110.835482 110.835482 0 0 0 110.778084-110.634589 110.835482 110.835482 0 0 0-110.778084-110.60589 110.835482 110.835482 0 0 0-110.778084 110.60589 110.835482 110.835482 0 0 0 110.778084 110.634589z"
                    p-id="3917"
                ></path>
            </svg>
            <svg
                @click="full"
                class="icon"
                style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                viewBox="0 0 1027 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2979"
            >
                <path
                    d="M733.549304 0l116.434359 116.23452-226.402521 226.40252 57.053835 57.068109 226.459617-226.445342 120.616689 120.41685V0H733.549304zM689.513507 619.855586l-57.068108 57.068109 224.232847 224.232847-122.64362 122.843458h293.676657V729.838022l-114.007751 114.207588-224.190025-224.190024zM338.197775 404.144414l57.068109-57.068109L171.033037 122.843458 293.676657 0H0v294.161978l114.022025-114.207588 224.17575 224.190024zM347.076305 624.294851L120.616689 850.754468 0 730.323343v293.676657h294.161978l-116.420084-116.23452 226.40252-226.40252-57.068109-57.068109z"
                    p-id="2980"
                ></path>
            </svg>
        </div>
    </div>
</template>

<script>
const Play = "playing";
const Load = "loading";
const Pause = "pause";
const Abort = "abort";
const EZuikit = require("./tools/ezuikit.js");
import getRandom from "./tools/getNoRepeatNum.js";
import { getHttps } from "./tools/getYsToken.js";
export default {
    name: "MonitorList",
    components: {},
    computed: {
        getId: function() {
            return "myPlayer" + this.id + getRandom(10) + "#";
        },
        getHls: function() {
            if (!this.hls) return "1";
            return getHttps(this.hls);
        }
    },
    props: ["id", "hls", "rtmp", "isBig", "camera"],
    data() {
        return {
            isReload: true,
            playState: Load,
            isPause: false,
            player: null
        };
    },
    beforeDestroy() {
        let player = this.player;
        if (player && player.hls && player.hls.destroy) {
            player.hls.destroy();
        }
    },
    methods: {
        getHttps,
        full() {
            this.player.video.webkitRequestFullScreen();
        },
        capture() {
            let scale = 1;
            let video = document.getElementById(this.getId);
            let canvas = document.createElement("canvas");
            canvas.width = video.videoWidth * scale;
            canvas.height = video.videoHeight * scale;
            canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
            let img_src = canvas.toDataURL();
            this.downBase64(
                `${this.camera && this.camera.device_name}截图${new Date().Format(
                    "yyyy-MM-dd hh-mm-ss"
                )}`,
                img_src
            );
        },
        downBase64(fileName, content) {
            let aLink = document.createElement("a");
            let blob = base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("click", true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);

            // aLink.dispatchEvent(evt);
            aLink.click();

            function base64ToBlob(code) {
                let parts = code.split(";base64,");
                let contentType = parts[0].split(":")[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {
                    type: contentType
                });
            }
        },
        refresh() {
            this.isReload = false;
            this.$nextTick(function() {
                this.isReload = true;
                this.$nextTick(function() {
                    this.initVideo();
                });
            });
        },
        pause() {
            if (this.playState == Play) {
                this.player.pause();
            } else if (this.playState == Pause) {
                this.player.play();
            }
        },
        initVideo() {
            this.player = null;
            this.playState = Load;
            // 正常的萤石摄像头
            let player = new EZuikit.EZUIPlayer(this.getId);
            if (!this.hls) {
                setTimeout(() => {
                    this.playState = Abort;
                }, 1000);
            }
            this.player = player;
            player.on("play", () => {
                this.playState = Play;
                setTimeout(() => {
                    this.player.play();
                }, 1000);
            });
            player.on("error", e => {
                if (e.type == "mediaError") {
                    return;
                }
                this.playState = Abort;
            });
            player.on("pause", e => {
                this.playState = Pause;
            });
        }
    },
    mounted() {
        this.initVideo();
    }
};
</script>

<style scoped="scoped">
.flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-box {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
}

.parse {
    background: rgba(0, 0, 0, 0.5);
}

.parse svg {
    cursor: pointer;
    color: #fff !important;
    width: 20%;
    height: 20%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.videoplay {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #000;
    overflow: hidden;
    position: relative;
}

.videoplay.big video {
    object-fit: contain;
}

.videoplay video {
    object-fit: fill;
    width: 100% !important;
    height: 100% !important;
}

.videoplay video:hover ~ .control,
.control:hover,
.parse:hover ~ .control {
    display: flex;
}

.control {
    z-index: 3;
    display: none;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    transition: display 2s;
    /* justify-content: space-between; */
    padding: 10px 5%;
    background: rgba(0, 0, 0, 0.6);
}

.control svg:first-child {
    margin-left: 0;
    margin-right: auto;
}

.big .control svg {
    width: 25px;
    height: 25px;
}

.control svg {
    margin-left: 30px;
    /* stroke-width:3; */
    width: 15px;
    height: 15px;
    cursor: pointer;
    opacity: 1;
    filter: grayscale(50%);
}

.control svg:hover {
    opacity: 1;
}

.container-loading {
    width: 50px;
    height: 50px;
    position: relative;
}

.container-loading.animation-4,
.container-loading.animation-5 {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
}

.container-loading .shape {
    position: absolute;
    border-radius: 1px;
}

.container-loading.animation-5 .shape {
    width: 50%;
    height: 50%;
}

.container-loading .shape.shape1 {
    left: 0;
    background-color: #5c6bc0;
}

.container-loading .shape.shape2 {
    right: 0;
    background-color: #8bc34a;
}

.container-loading .shape.shape3 {
    bottom: 0;
    background-color: #ffb74d;
}

.container-loading .shape.shape4 {
    bottom: 0;
    right: 0;
    background-color: #f44336;
}

.animation-5 .shape1 {
    animation: animation5shape1 2s ease 0s infinite reverse;
}

@-webkit-keyframes animation5shape1 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(0, 100%);
        transform: translate(0, 100%);
    }

    50% {
        -webkit-transform: translate(100%, 100%);
        transform: translate(100%, 100%);
    }

    75% {
        -webkit-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }
}

@keyframes animation5shape1 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(0, 100%);
        transform: translate(0, 100%);
    }

    50% {
        -webkit-transform: translate(100%, 100%);
        transform: translate(100%, 100%);
    }

    75% {
        -webkit-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }
}

.animation-5 .shape2 {
    animation: animation5shape2 2s ease 0s infinite reverse;
}

@-webkit-keyframes animation5shape2 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }

    50% {
        -webkit-transform: translate(-100%, 100%);
        transform: translate(-100%, 100%);
    }

    75% {
        -webkit-transform: translate(0, 100%);
        transform: translate(0, 100%);
    }
}

@keyframes animation5shape2 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }

    50% {
        -webkit-transform: translate(-100%, 100%);
        transform: translate(-100%, 100%);
    }

    75% {
        -webkit-transform: translate(0, 100%);
        transform: translate(0, 100%);
    }
}

.animation-5 .shape3 {
    animation: animation5shape3 2s ease 0s infinite reverse;
}

@-webkit-keyframes animation5shape3 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }

    50% {
        -webkit-transform: translate(100%, -100%);
        transform: translate(100%, -100%);
    }

    75% {
        -webkit-transform: translate(0, -100%);
        transform: translate(0, -100%);
    }
}

@keyframes animation5shape3 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }

    50% {
        -webkit-transform: translate(100%, -100%);
        transform: translate(100%, -100%);
    }

    75% {
        -webkit-transform: translate(0, -100%);
        transform: translate(0, -100%);
    }
}

.animation-5 .shape4 {
    animation: animation5shape4 2s ease 0s infinite reverse;
}

@-webkit-keyframes animation5shape4 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(0, -100%);
        transform: translate(0, -100%);
    }

    50% {
        -webkit-transform: translate(-100%, -100%);
        transform: translate(-100%, -100%);
    }

    75% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }
}

@keyframes animation5shape4 {
    0% {
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
    }

    25% {
        -webkit-transform: translate(0, -100%);
        transform: translate(0, -100%);
    }

    50% {
        -webkit-transform: translate(-100%, -100%);
        transform: translate(-100%, -100%);
    }

    75% {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100%, 0);
    }
}
</style>
